module.exports = __webpack_public_path__ + "img/logo2.d76c7af2.png";